import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { EnvironnementProvider } from '@le_cedre/portal-lib';

@Injectable({
    providedIn: 'root',
})
export class PortalEnvironnementProvider implements EnvironnementProvider {
    getEnvironnement() {
        return environment;
    }
}
